export class ClientUserSessionState {
    static deserialize(data) {
        const user = new ClientUserSessionState();
        user.id = data.id;
        return user;
    }
}
